<template>
  <vs-popup class="customer-sample-order-create-popup" :title="`UPDATE CREDIT NOTE ~ ${credit_note_details.credit_note_code}`" @close="OPEN = false"
    :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>
      <template slot="actions">
        <div class="flex flex-wrap items-center justify-end mt-1">
          <vx-tooltip class="ml-4 mt-1" text="VIEW/CREATE PDF" position="top">
            <vs-button @click.stop="onClickCreditNotePdf()" size="small" color="primary" type="filled" icon-pack="feather"
              icon="icon-printer">Credit note pdf</vs-button>
          </vx-tooltip>
        </div>
      </template>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="popup" @submit.prevent="handleSubmit(onClickUpdateCreditNote)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="created_at" name="created_at" rules="required" v-slot="{ errors }">
                <small class="label">Create Date & Time </small>
                <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                  v-model="form.created_at" placeholder="Choose Date" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3" id="produc_order_credit_items_table">
            <div class="vx-col md:w-full md:s-full w-full md:mb-0">
              <vs-table v-if="cartItems.length > 0" :data="cartItems" stripe
                :sst="true">
                <template slot="thead">
                  <vs-th width="20%">ITS PRODUCT CODE</vs-th>
                  <vs-th width="15%">UNIT PRICE (KG/{{ account_currency }})</vs-th>
                  <vs-th width="10%">ORDER QUANTITY (KG)</vs-th>
                  <vs-th width="15%">CREDITED QUANTITY (KG)</vs-th>
                  <vs-th width="20%">CREDIT QUANTITY (KG)</vs-th>
                  <vs-th width="20%">CREDIT AMOUNT Excl VAT ({{ account_currency }})</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="data[indextr].formulation_code">
                      {{ data[indextr].formulation_code }}
                    </vs-td>

                    <vs-td :data="data[indextr].price">
                      {{ data[indextr].price }}
                    </vs-td>

                    <vs-td :data="data[indextr].quantity">
                      {{ data[indextr].quantity }}
                    </vs-td>

                    <vs-td>
                      {{ creditQuantityGenerator(tr) }}
                    </vs-td>

                    <vs-td :data="data[indextr].credited_quantity">
                      <ValidationProvider v-if="data[indextr].batches.length === 0" :vid="indextr + 'credited_quantity'"
                        :name="indextr + 'credited_quantity'" :rules="`min_qty:${data[indextr].validation_quantity}`"
                        v-slot="{ errors }">
                        <vs-input type="text" v-model="data[indextr].credited_quantity" class="w-full" @click.stop=""
                          :name="'credited_quantity'" :danger="!!errors[0]" :danger-text="errors[0]"
                          val-icon-danger="icon-x" val-icon-pack="feather" />
                      </ValidationProvider>
                      <span class="text-primary" v-if="data[indextr].batches.length !== 0">
                        Expand to view item batch
                      </span>
                    </vs-td>


                    <vs-td class="font-bold" :data="data[indextr].price">
                      {{ calculateRowTotal(data[indextr]) }}
                      <!-- {{data[indextr].credited_quantity ? (Number(data[indextr].price) * data[indextr].credited_quantity).toFixed(2) : '0.00'}} -->
                    </vs-td>

                    <template class="expand-user" slot="expand">
                      <div class="con-expand-users w-full p-12">
                        <vs-table :data="data[indextr].batches" stripe :sst="true">
                          <template slot="thead">
                            <vs-th>WO CODE</vs-th>
                            <vs-th>MAN DATE</vs-th>
                            <vs-th>EXP DATE</vs-th>
                            <vs-th>BATCH QUANTITY (KG)</vs-th>
                            <vs-th>CREDITED QUANTITY (KG)</vs-th>
                            <vs-th>CREDIT QUANTITY (KG)</vs-th>
                          </template>
                          <template slot-scope="{data}">
                            <vs-tr :key="index_item" v-for="(tr_item, index_item) in data">
                              <vs-td>
                                {{ tr_item.work_order_code }}
                              </vs-td>
                              <vs-td>
                                {{ tr_item.manufacture_date }}
                              </vs-td>
                              <vs-td>
                                {{ tr_item.expiration_date }}
                              </vs-td>
                              <vs-td>
                                {{ tr_item.completed_quantity }}
                              </vs-td>
                              <vs-td>
                                {{ tr_item.already_credit_batch_quantity }}
                              </vs-td>
                              <vs-td>
                                <ValidationProvider :vid="index_item + 'credited_quantity'"
                                  :name="index_item + 'credited_quantity'"
                                  :rules="`min_qty:${tr_item.validation_quantity}`" v-slot="{ errors }">
                                  <input v-on:input="onInputBatchQty(indextr, index_item, tr_item.credited_quantity)" type="number" step="0.0001"
                                    style="border: 1px solid #CCCCCC; outline: none; width: 30px"
                                    class="w-full h-10 rounded-lg m-2 p-2" v-model="cartItems[indextr].batches[index_item].credited_quantity" />
                                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                                </ValidationProvider>
                              </vs-td>
                            </vs-tr>
                          </template>
                        </vs-table>
                      </div>
                    </template>

                  </vs-tr>
                  <vs-tr>
                    <vs-td colspan="6" style="font-weight: bolder">Total</vs-td>
                    <vs-td style="font-weight: bolder">{{ totalTableCreditedCalculator() }}</vs-td>
                  </vs-tr>
                </template>

              </vs-table>
              <vs-table noDataText="Click add to add additional cost" class="mt-8" :data="form.add_cost">

                <template slot="header">
                  <h5 class="mb-4">Additional cost</h5>
                  <div class="flex flex-wrap items-center justify-end mt-8">
                    <vs-button @click.stop="onClickAddAddCost()" size="small" class="ml-auto mt-2 mb-4">Add</vs-button>
                  </div>
                </template>

                <template slot="thead">
                  <vs-th>NAME</vs-th>
                  <vs-th>AMOUNT Excl VAT ({{ account_currency }})</vs-th>
                  <vs-th>VAT PERCENTAGE (%)</vs-th>
                  <vs-th>AMOUNT Incl VAT ({{ account_currency }})</vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="index_cost" v-for="(tr_cost, index_cost) in data">

                    <vs-td :data="tr_cost.name">
                      <ValidationProvider :vid="index_cost + 'name'" :name="index_cost + 'name'" rules="required"
                        v-slot="{ errors }">
                        <vs-input type="text" v-model="tr_cost.name" class="w-full" :name="index_cost + 'name'"
                          :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                          val-icon-pack="feather" />
                      </ValidationProvider>
                    </vs-td>

                    <vs-td :data="tr_cost.amount">
                      <ValidationProvider :vid="index_cost + 'amount'" :name="index_cost + 'amount'" rules="required"
                        v-slot="{ errors }">
                        <vs-input type="text" v-model="tr_cost.amount_ex_vat" class="w-full" :name="index_cost + 'amount'"
                          :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                          val-icon-pack="feather" />
                      </ValidationProvider>
                    </vs-td>

                    <vs-td :data="tr_cost.vat_percent">
                      <ValidationProvider :vid="index_cost + 'vat_percent'" :name="index_cost + 'vat_percent'"
                        rules="required" v-slot="{ errors }">
                        <vs-input type="text" v-model="tr_cost.vat_percent" class="w-full"
                          :name="index_cost + 'vat_percent'" :danger="!!errors[0]" :danger-text="errors[0]"
                          val-icon-danger="icon-x" val-icon-pack="feather" />
                      </ValidationProvider>
                    </vs-td>

                    <vs-td :data="tr_cost.amount_in_vat">
                      {{ ((tr_cost.amount_ex_vat * tr_cost.vat_percent) / 100 ) + Number(tr_cost.amount_ex_vat) }}
                    </vs-td>

                    <vs-td>
                      <div class="vx-row">
                        <vx-tooltip class="ml-2" text="Remove" position="top">
                          <vs-button @click.stop="onClickRemoveAddCost(index_cost)" size="small" color="danger"
                            type="border" icon-pack="feather" icon="icon-trash"></vs-button>
                        </vx-tooltip>
                      </div>
                    </vs-td>

                  </vs-tr>
                </template>

              </vs-table>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="belongs_to_product_order_id" name="belongs_to_product_order_id" rules="required"
                v-slot="{ errors }">
                <small class="label">Related SO</small>
                <vs-input readonly :value="product_order_code" name="belongs_to_product_order_id" class="w-full required"
                  label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                  val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="credit_amount" name="credit_amount" rules="" v-slot="{ errors }">
                <small class="label"><span class="text-bold">Credit amount ({{ account_currency }}) </span></small>
                <!-- <p class="mt-2 font-bold text-lg">{{ totalCreditedCalculator() }}</p> -->
                <vx-input-group class="">
                  <template slot="prepend">
                    <div class="prepend-text bg-success">
                      <span>{{ account_currency }}</span>
                    </div>
                  </template>
                  <vs-input readonly :value="totalCreditedCalculator()" name="credit_amount" class="w-full" label="" />
                </vx-input-group>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="form.note" height="100px" />
              </ValidationProvider>
            </div>
          </div>
          <!--           Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'create-edit-credit-note'" button="submit" class="ml-auto mt-2">Update</vs-button>
            <vs-button @click="open = false" class="ml-4 mt-2" type="border" color="warning">Cancel</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
    <credit-note-document-pop-up ref="creditNoteDocumentPopUp" />
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const CustomerRepository = RepositoryFactory.get('customer')

import CreditNoteDocumentPopUp from "@/components/popups/customer/credit-note/documents/CreditNoteDocumentPopUp";
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'

function initialState() {
  return {
    open: false,
    credit_note_id: '',
    form: {
      add_cost: []
    },
    cartItems: [],
    customerId: '',
    credit_note_details: {
      credit_note_code: ''
    },
    product_order_code: '',
    account_currency: 'GBP'
  }
}

export default {
  name: 'UpdateCreditNoteFromOrderPopUp',
  data() {
    return initialState()
  },
  components: {
    CreditNoteDocumentPopUp,
    flatPickr,
  },
  props: {
    // account_currency: { type: String, default: 'GBP' }
  },
  methods: {
    async openPopup(credit_note_id, customerId) {
      await this.$vs.loading()
      try {
        await Object.assign(this.$data, initialState())

        this.credit_note_id = credit_note_id
        this.customerId = customerId
        await this.fetchCustomerCreditNote()
        await this.getItemsInItemsCart()
        this.open = true;

      } catch (error) {
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    async onClickUpdateCreditNote() {
      const vue = this;
      await this.$vs.loading({
        container: '#produc_order_credit_items_table',
        scale: 0.45
      })
      try {
        this.form.customer_id = this.customerId
        this.form.credit_amount = this.totalCreditedCalculator()

        this.form.product_items = this.cartItems.map((n) => {
          // Calculate the total batch quantity if batches are present
          const totalBatchQuantity = n.batches && n.batches.length > 0 
            ? n.batches.reduce((sum, batch) => sum + Number(batch.credited_quantity), 0)
            : 0;

          // Set amount to either the sum of main credited quantity and batch quantities (if batches exist) or just main credited quantity
          const mainAmount = n.batches && n.batches.length > 0 
            ? (totalBatchQuantity).toFixed(3)
            : Number(n.credited_quantity).toFixed(3);

          return {
            product_order_item_id: n.id,
            amount: mainAmount,
            batches: n.batches.map((y) => {
              return { 
                work_order_id: y.work_order_id, 
                quantity: Number(y.credited_quantity).toFixed(4) 
              };
            })
          };
        });

        this.form.add_cost = this.form.add_cost.map((n) => {
            return {
              amount: Number(n.amount_ex_vat).toFixed(2),
              vat_percent: Number(n.vat_percent).toFixed(2),
              name: n.name,
            }
         })

         //temp fix date formatter
         this.form.created_at = this.form.created_at + ' ' + '00:00' 
        await CustomerRepository.updateCustomerCreditNote(this.credit_note_id, this.form)
        this.showSuccessMessage('Customer credit note updated successfully')
        this.open = false;
        await vue.$parent.refreshData()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#produc_order_credit_items_table > .con-vs-loading')
    },
    async getItemsInItemsCart() {
      try {
        const { data } = (await CustomerRepository.getCustomerProductOrder(this.credit_note_details.belongs_to_product_order.id)).data
        this.cartItems = data.formulation_items
        
        const belongs_order_item_ids = this.credit_note_details.belongs_to_product_items.map((x) => x.product_order_item_id)
        this.cartItems = this.cartItems.filter((x) => belongs_order_item_ids.includes(x.id))

        this.cartItems = this.cartItems.map((n) => {
          let find = this.credit_note_details.belongs_to_product_items.find((m) => m.product_order_item_id === n.id)
          n.credited_quantity = find.total_quantity
          // new validations
          const related_existing_cn_item = data.created_credit_note.filter((x) => x.status === 'Active').map(item => item.product_items).flat().filter((x) => x.product_order_item_id === n.id)
          const already_credit_quantity = related_existing_cn_item.reduce((acc, cur) => { return acc + Number(cur.total_quantity) }, 0)
          n.remaining_credited_quantity = Number(n.quantity) - Number(already_credit_quantity)
          n.already_credit_quantity = already_credit_quantity
          n.validation_quantity = Number(n.credited_quantity) +  Number(n.remaining_credited_quantity)
          n.price = find.price ? find.price : n.price
          // end new validations
          const all_batches = this.credit_note_details.belongs_to_product_items.map(item => item.batches).flat();
          n.batches = n.inventory_stock.filter((x) => x.status !== 'Returned').map((y) => {
            const find = all_batches.find((z) => z.work_order_id === y.work_order_id)
            y.credited_quantity = find ? find.quantity : 0
            // new validations
            const related_existing_cn_batch = related_existing_cn_item.map(item => item.batches).flat().filter((x) => x.work_order_id === y.work_order_id)
            const already_credit_batch_quantity = related_existing_cn_batch.reduce((acc, cur) => { return acc + Number(cur.quantity) }, 0)
            y.already_credit_batch_quantity = already_credit_batch_quantity
            y.remaining_credited_quantity = Number(y.completed_quantity) - Number(already_credit_batch_quantity)
            y.validation_quantity = Number(y.credited_quantity) + Number(y.remaining_credited_quantity)
            // end new validations
            return y
          })
          return n;
        })
        this.product_order_code = data.product_order_code
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchCustomerCreditNote() {
      try {
        const { data } = (await CustomerRepository.getCustomerCreditNote(this.credit_note_id)).data
        this.credit_note_details = data
        this.account_currency = this.credit_note_details.customer.account_currency
        this.form.belongs_to_product_order_id = data.belongs_to_product_order.id
        this.form.credit_amount = data.credit_amount
        this.form.note = data.note
        this.form.created_at = data.created_at
        this.form.add_cost = data.add_cost
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    totalCreditedCalculator() {
      let item_quantity = 0
      let batch_quantity = 0
      let total = 0
      this.cartItems.forEach((m) => {
        item_quantity = Number(m.price) * Number(m.credited_quantity)
        batch_quantity = m.batches.reduce((a, c) => a + (Number(c.credited_quantity) * Number(m.price)), 0)
        if (m.batches.length > 0) {
          total = total + batch_quantity
        } else {
          total = total + item_quantity
        }
      })
      this.form.add_cost.forEach((m) => {
        total = total + ((m.amount_ex_vat * m.vat_percent) / 100 ) + Number(m.amount_ex_vat)
      })
      return Number(total).toFixed(2)
    },
    totalTableCreditedCalculator() {
      let item_quantity = 0
      let batch_quantity = 0
      let total = 0
      this.cartItems.forEach((m) => {
        item_quantity =  Number(m.price) * Number(m.credited_quantity)
        batch_quantity = m.batches.reduce((a, c) => a + (Number(c.credited_quantity) * Number(m.price)), 0)
        if (m.batches.length > 0) {
          total = total + batch_quantity
        } else {
          total = total + item_quantity
        }
      })
      return Number(total).toFixed(2)
    },
    calculateRowTotal(tr) {
      if (tr.batches.length === 0) {
        return Number(tr.price * tr.credited_quantity).toFixed(2)
      } else {
        return Number(tr.batches.reduce((a, c) => a + (Number(c.credited_quantity) * Number(tr.price)), 0)).toFixed(2)
      }
    },
    onInputBatchQty(x, y, z) {
      this.cartItems[x].batches[y].credited_quantity = Number(z)
      this.totalCreditedCalculator()
      this.totalTableCreditedCalculator()
      this.$forceUpdate();
      this.$refs.form.validate()
    },
    async onClickCreditNotePdf() {
      let routeData = this.$router.resolve({ name: 'credit-note-print-view', params: { secret_code: this.credit_note_details.credit_note_secret_code, id: this.credit_note_id } })
      window.open(routeData.href, '_blank');
    },
    onClickAddAddCost() {
      this.form.add_cost.push({ name: null, amount: null })
    },
    onClickRemoveAddCost(index) {
      this.form.add_cost.splice(index, 1)
    },
    creditQuantityGenerator(row_data) {
      if(row_data.batches.length === 0) return row_data.already_credit_quantity
      return row_data.batches.reduce((acc, cur) => { return acc + Number(cur.already_credit_batch_quantity) }, 0)
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.customer-sample-order-create-popup>>>.vs-popup {
  /*min-height: 80% !important;*/
  min-width: 60% !important;
}

.loader {
  text-align: center;
  color: #bbbbbb;
}</style>
